import {
  CALIBRATE1_FAIL,
  CALIBRATE1_REQUEST,
  CALIBRATE1_SUCCESS,
  CALIBRATE3_FAIL,
  CALIBRATE3_REQUEST,
  CALIBRATE3_SUCCESS,
  CALIBRATE_FAIL,
  CALIBRATE_REQUEST,
  CALIBRATE_SUCCESS,
  CALIBRATION_SHOW_FAIL,
  CALIBRATION_SHOW_REQUEST,
  CALIBRATION_SHOW_SUCCESS,
  GET_KEYPAD_LOCK_STATUS_FAIL,
  GET_KEYPAD_LOCK_STATUS_REQUEST,
  GET_KEYPAD_LOCK_STATUS_SUCCESS,
  GET_LPI_CALIBRATION_LOG_FAIL,
  GET_LPI_CALIBRATION_LOG_REQUEST,
  GET_LPI_CALIBRATION_LOG_SUCCESS,
  GET_LPI_DEVICE_LOG_FAIL,
  GET_LPI_DEVICE_LOG_REQUEST,
  GET_LPI_DEVICE_LOG_SUCCESS,
  GET_READ_WEIGHT_FAIL,
  GET_READ_WEIGHT_REQUEST,
  GET_READ_WEIGHT_SUCCESS,
  GET_SINGLE_LPI_CALIBRATION_LOG_FAIL,
  GET_SINGLE_LPI_CALIBRATION_LOG_REQUEST,
  GET_SINGLE_LPI_CALIBRATION_LOG_SUCCESS,
  GET_SINGLE_LPI_DEVICE_LOG_FAIL,
  GET_SINGLE_LPI_DEVICE_LOG_REQUEST,
  GET_SINGLE_LPI_DEVICE_LOG_SUCCESS,
  KEYPAD_LOCK_FAIL,
  KEYPAD_LOCK_REQUEST,
  KEYPAD_LOCK_SUCCESS,
  KEYPAD_UNLOCK_FAIL,
  KEYPAD_UNLOCK_REQUEST,
  KEYPAD_UNLOCK_SUCCESS,
  LPI_RESET_FAIL,
  LPI_RESET_REQUEST,
  LPI_RESET_SUCCESS,
  RESET_READ_WEIGHT,
} from "src/constants/types";

export const lpiReducers = (state = {}, actions) => {
  const { payload } = actions;

  switch (actions.type) {
    case GET_LPI_DEVICE_LOG_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_LPI_DEVICE_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        deviceLogs: payload,
      };
    case GET_LPI_DEVICE_LOG_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_LPI_CALIBRATION_LOG_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_LPI_CALIBRATION_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        calibrationLogs: payload,
      };
    case GET_LPI_CALIBRATION_LOG_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_SINGLE_LPI_DEVICE_LOG_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_LPI_DEVICE_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        deviceLog: payload,
      };
    case GET_SINGLE_LPI_DEVICE_LOG_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_SINGLE_LPI_CALIBRATION_LOG_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_LPI_CALIBRATION_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        calibrationLog: payload,
      };
    case GET_SINGLE_LPI_CALIBRATION_LOG_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case CALIBRATION_SHOW_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case CALIBRATION_SHOW_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CALIBRATION_SHOW_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_KEYPAD_LOCK_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_KEYPAD_LOCK_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        KeypadIsLocked: payload,
      };
    case GET_KEYPAD_LOCK_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case KEYPAD_LOCK_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case KEYPAD_LOCK_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case KEYPAD_LOCK_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case LPI_RESET_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case LPI_RESET_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case LPI_RESET_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case KEYPAD_UNLOCK_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case KEYPAD_UNLOCK_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case KEYPAD_UNLOCK_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_READ_WEIGHT_REQUEST:
      return {
        ...state,
      };
    case GET_READ_WEIGHT_SUCCESS:
      return {
        ...state,
        ReadWeight: payload,
        error: "",
      };
    case GET_READ_WEIGHT_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CALIBRATE1_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case CALIBRATE1_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CALIBRATE1_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case CALIBRATE3_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case CALIBRATE3_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CALIBRATE3_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case CALIBRATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case CALIBRATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CALIBRATE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case RESET_READ_WEIGHT:
      return {
        ...state,
        ReadWeight: 0,
      };

    default:
      return state;
  }
};
